<template>
  <div
    ref="treeSelectSection"
    :class="$style.treeSelectSection"
    :style="{ height: dynamicHeight + 'px' }"
  >
    <!-- 分类区域 -->
    <div :class="$style.treeCategory">
      <div
        v-for="(category, index) in subCategory"
        :key="category.id"
        :class="[
          $style.categoryItem,
          { [$style.active]: activeCategory === category.id },
        ]"
        @click="handleCategoryClick(category)"
      >
        <i v-if="index !== 0" :class="$style.up"></i>
        <div :class="$style.categoryName">
          <span :class="$style.categoryText">{{ category.categoryName }}</span>
        </div>
        <i v-if="categories.length - 1 !== index" :class="$style.down"></i>
      </div>
    </div>

    <!-- 分类列表区域 -->
    <FlexShrinkWrapper :class="$style.treeList">
      <!-- 筛选插槽 -->
      <slot name="filter"></slot>
      <!-- 列表插槽 -->
      <slot name="list"></slot>
    </FlexShrinkWrapper>
  </div>
</template>

<script>
  import FlexShrinkWrapper from './FlexShrinkWrapper.vue'
  import Vue from 'vue'

  export default Vue.extend({
    name: 'TreeSelectSection',

    components: {
      FlexShrinkWrapper,
    },

    props: {
      categories: {
        type: Array,
        default: () => [],
      },
      defaultActive: {
        type: [String, Number],
        default: null,
      },
    },

    data() {
      return {
        activeCategory: null,
        parentActiveCategory: null,
        dynamicHeight: 0, // 动态计算的高度
      }
    },

    computed: {
      // 纯计算属性：只返回子分类列表，不产生副作用
      subCategory() {
        if (this.parentActiveCategory) {
          const parentCategory = this.categories.find(
            category => category.id === this.parentActiveCategory,
          )
          return parentCategory ? parentCategory.children || [] : []
        }
        return []
      },
    },

    watch: {
      defaultActive(newVal) {
        this.parentActiveCategory = newVal
      },

      // 监听子分类变化，自动设置第一个为激活状态
      subCategory: {
        handler(newList) {
          if (newList && newList.length > 0) {
            // 如果当前激活的分类不在新列表中，则设置第一个为激活状态
            const isCurrentActiveValid = newList.some(
              item => item.id === this.activeCategory,
            )
            if (!isCurrentActiveValid) {
              this.activeCategory = newList[0].id
            }
          } else {
            this.activeCategory = null
          }
        },
        immediate: true,
      },
    },

    mounted() {
      // 组件挂载后计算动态高度
      this.calculateDynamicHeight()
    },

    methods: {
      handleCategoryClick(category) {
        this.activeCategory = category.id

        // 触发分类切换事件
        this.$emit('subchange', category)
      },

      // 计算动态高度：屏幕尺寸 - 组件顶部距离
      calculateDynamicHeight() {
        this.$nextTick(() => {
          const element = this.$refs.treeSelectSection
          if (element) {
            // 获取组件顶部距离视口的距离
            const rect = element.getBoundingClientRect()
            const topOffset = rect.top

            // 计算动态高度：屏幕高度 - 组件顶部距离
            const screenHeight = window.innerHeight
            const calculatedHeight = screenHeight - topOffset

            // 设置最小高度，避免高度过小
            this.dynamicHeight = Math.max(calculatedHeight, 200)
          }
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .treeSelectSection {
    background-color: #fff;
    display: flex;
    overflow: hidden;
  }

  .treeCategory {
    width: 107px;
    background-color: #f5f8fa;
    overflow-y: auto;
    height: 100%;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .categoryItem {
    padding: 18px 6px 18px 0;
    position: relative;

    &.active {
      background-color: #fff;

      i {
        position: absolute;
        right: 0;
        height: 12px;
        width: 12px;

        &::before {
          content: '';
          display: block;
          height: 100%;
          width: 100%;
        }

        &.up {
          background-color: #fff;
          top: -12px;

          &::before {
            border-radius: 0 0 12px 0;
            background: #f5f8fa;
          }
        }

        &.down {
          background-color: #fff;
          bottom: -12px;

          &::before {
            border-radius: 0 12px 0 0;
            background: #f5f8fa;
          }
        }
      }

      .categoryName {
        color: #ff840a;
        font-weight: 500;
        padding-left: 0;

        &::before {
          content: '';
          margin-right: 10px;
          width: 3px;
          height: 12px;
          // 背景垂直渐变
          background: linear-gradient(180deg, #ffba18 0%, #ff840a 100%);
          border-radius: 0 2px 2px 0;
        }
      }
    }
  }

  .categoryName {
    font-size: 13px;
    color: #999;
    line-height: normal;
    transition: color 0.3s ease;
    word-spacing: nowrap;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    padding-left: 10px;
    box-sizing: border-box;

    .categoryText {
      width: 90px;
      flex: 0 90px;
      // 文本溢出
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
  }

  .treeList {
    box-sizing: border-box;
    padding-left: 8px;
    padding-right: 12px;
  }
</style>
